/* eslint-disable prettier/prettier */
/**
 * Asynchronously loads the component for FeaturePage
 */
import { loadable } from '@elliemae/pui-app-sdk';

export const LoadablePipelineConfiguration = loadable(
  () =>
    import(
      /* webpackChunkName: "pipeline" */ /* webpackPrefetch: true */ './pipelineComponent'
    ),
);
export const LoadablePipelineRunDetailsPage = loadable(
  () =>
    import(
      // eslint-disable-next-line import/no-unresolved
      /* webpackChunkName: "runDetailsPage" */ /* webpackPrefetch: true */ './pipelineRunDetailsComponent'
    ),
);
export const LoadablePipelineClientRunDetailsPage = loadable(
  () =>
    import(
      // eslint-disable-next-line import/no-unresolved
      /* webpackChunkName: "runDetailsPage" */ /* webpackPrefetch: true */ './clientRun'
    ),
);
